import styled from 'styled-components';

export const AuditDetailWrapper = styled.div`
  padding: 16px;
  overflow: auto;
  max-height: 60vh;

  .title {
    font-weight: 600;
    margin-right: 8px;
  }
  .__json-pretty__ .__json-string__ {
    color: rgb(51, 204, 51);
  }
  .__json-pretty__ .__json-key__ {
    color: #eb0f5f;
  }

  .expanded-content {
    padding: 12px 16px;
    margin: 8px 0;
    border-radius: 4px;

    pre {
      max-height: 300px;
      overflow: auto;
      margin: 0;
      padding: 8px;
      background: rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
  }
`;

export const AuditLogWrapper = styled.div`
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #fff;
  .shell-table {
    margin-top: 10px;
    th {
      font-weight: 600;
      font-size: 14px;
    }
    td {
      font-size: 12px;
      font-weight: 400;
    }
  }
`;
